export default __webpack_public_path__ + "fc0337b9cf1cce2e6e1ec2bfd1daab86.woff2";